export class DisableResourceOverrideLimitsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "updatedResource",
            "baseName": "updatedResource",
            "type": "InventoryResource",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DisableResourceOverrideLimitsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
